/**
 * Created by Sumit on 7/13/2017.
 */
import {
  GetCollectionFilterListQuery,
  GetCollectionFilterListResp

} from "../../autogenerated/ZoomBridge";
import { ErrorId } from "../../protocol/ErrorId";

export default class GetCollectionFilterList {
  /**
   *
   * @param all,       true,If need to get all available filters
   */
  constructor(all) {
    this.all = all;
  }

  /**
   * This method will return GetCollectionFilterListResp which contains the following fields:-
   *  collectionFilterNames,       List of Collection Names
   *
   * @returns {Promise.<GetCollectionFilterListResp,ErrorId>}
   */
  run() {
    const query = new GetCollectionFilterListQuery();
    this.all = true;
    query.message = this.all;
    return query.run();
  }
}